export const productsPerPageOptions = [
  { label: '20', value: '20' },
  { label: '40', value: '40' },
  { label: '60', value: '60' },
];

export const sortOptions = ['rel', 'asc', 'desc'];

export const MIN_PHONE_NUMBER_LENGTH = 9;
export const MAX_PHONE_NUMBER_LENGTH = 14;
